export default __webpack_public_path__ + "static/media/green_check.1264a5b5.png";